<template>
    <page>
        <module title="授信账单详情">
            <div v-if="billInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="账单状态">
                        <span v-if="billInfo.tran_state==0">
                          <span style="color:#000">{{stateName[billInfo.tran_state]}}</span>
                          <span style="color:#bbb" v-if="billInfo.order_state == 2">(未发货)</span>
                          <span style="color:#f55" v-else-if="billInfo.invoice_state == 1">(未开票)</span>
                        </span>
                        <span v-if="billInfo.tran_state==1">
                          <span style="color:#182eff">{{stateName[billInfo.tran_state]}}</span>
                          <span style="color:#f55" v-if="billInfo.exp_flag == 1">(已逾期)</span>
                        </span>
                        <span v-if="billInfo.tran_state==2"><span style="color:#182eff">{{stateName[billInfo.tran_state]}}</span></span>
                        <span v-if="billInfo.tran_state==3"><span style="color:#000">{{stateName[billInfo.tran_state]}}</span></span>
                        <span v-if="billInfo.tran_state==4"><span style="color:#999">{{stateName[billInfo.tran_state]}}</span></span>
                    </c-detail-item>
                    <c-detail-item label="订单号">{{billInfo.tran_number}}</c-detail-item>
                    <c-detail-item label="下单时间">{{billInfo.order_create_date}}</c-detail-item>
                    <c-detail-item label="客户电话">{{billInfo.user_manage_mobilephone}}</c-detail-item>
                    <c-detail-item label="客户名称">{{billInfo.nick_name}}</c-detail-item>
                    <c-detail-item label="交易金额">￥{{parseFloat(billInfo.tran_amount).toFixed(2)}}</c-detail-item>
                    <c-detail-item label="已出账金额">
                        <span v-if="billInfo.out_account_amount>0">￥{{parseFloat(billInfo.out_account_amount).toFixed(2)}}</span>
                        <span v-else>--</span>
                    </c-detail-item>
                    <c-detail-item label="已退款金额">
                      <span v-if="billInfo.tran_state==4">￥{{parseFloat(billInfo.refund_amount + billInfo.return_amount).toFixed(2)}}</span>
                      <span v-else>--</span>
                    </c-detail-item>
                    <c-detail-item label="已还款金额">
                      <span v-if="billInfo.tran_state==0 || billInfo.tran_state==4">--</span>
                      <span v-else>￥{{parseFloat(billInfo.repay_amount).toFixed(2)}}</span>
                    </c-detail-item>
                    <c-detail-item label="当前欠款">
                      <span v-if="billInfo.tran_state==0 || billInfo.tran_state==4">--</span>
                      <span v-else>￥{{parseFloat(billInfo.tran_amount - billInfo.refund_amount - billInfo.return_amount - billInfo.repay_amount).toFixed(2)}}</span>
                    </c-detail-item>
                    <c-detail-item label="出账时间">
                      <span v-if="billInfo.tran_state==0 || billInfo.tran_state==4">--</span>
                      <span v-else>{{billInfo.bill_date}}</span>
                    </c-detail-item>
                    <c-detail-item label="逾期时间">
                      <span v-if="billInfo.tran_state==1 && billInfo.exp_flag == 0">{{billInfo.exp_date}}</span>
                      <span style="color:red" v-if="billInfo.tran_state==1 && billInfo.exp_flag == 1">{{billInfo.exp_date}}</span>
                      <span v-if="billInfo.tran_state!=1">--</span>
                    </c-detail-item>

                    <c-detail-item label="出账明细" full>
                        <c-table v-model="sendList" height="auto" border>
                          <c-table-column
                              label="类型"
                              name="type"
                              width="80"
                          >
                            <template v-slot="{data}">
                              <span v-if="data.type==1"><span>商品金额</span></span>
                              <span v-if="data.type==2"><span style="color:blue">其他费用</span></span>
                            </template>
                          </c-table-column>

                          <c-table-column
                                    label="包裹编码"
                                    name="pack_number"
                                    width="110"
                            >
                              <template v-slot="{data}">
                                <span v-if="data.type==1">{{data.pack_number}}</span>
                                <span v-if="data.type==2">--</span>
                              </template>
                            </c-table-column>

                            <c-table-column
                                label="数量"
                                name="product_count"
                                width="80"
                            >
                              <template v-slot="{data}">
                                <span v-if="data.type==1">{{data.product_count}}</span>
                                <span v-if="data.type==2">--</span>
                              </template>
                            </c-table-column>

                            <c-table-column
                                label="金额"
                                name="product_money"
                                width="80"
                            >
                              <template v-slot="{data}">
                                ￥{{parseFloat(data.product_money).toFixed(2)}}
                              </template>
                            </c-table-column>

                            <c-table-column
                                label="出账时间"
                                name="create_date"
                                width="150"
                            ></c-table-column>
                        </c-table>
                    </c-detail-item>
                    <c-detail-item label="还款明细" full>
                        <c-table v-model="repayList" height="auto" border>
                          <c-table-column
                              label="还款单号"
                              name="repay_number"
                              width="130"
                          ></c-table-column>

                          <c-table-column
                              label="还款金额"
                              name="amount_money"
                              width="80"
                          >
                            <template v-slot="{data}">
                              ￥{{parseFloat(data.amount_money).toFixed(2)}}
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="还款凭证"
                              name="voucher_file"
                              width="80"
                          >
                            <template v-slot="{data}">
                              <c-image v-if="data.voucher_file" :src="data.voucher_file" size="60" preview></c-image>
                              <span v-else style="color:#999">--</span>
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="还款时间"
                              name="repay_date"
                              width="150"
                          ></c-table-column>

                          <c-table-column
                              label="还款类型"
                              name="is_finish"
                              width="80"
                          >
                            <template v-slot="{data}">
                              <span v-if="data.is_finish == 0">正常还款</span>
                              <span v-else style="color:red">特结还款</span>
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="还款说明"
                              name="repay_remark"
                              width="100"
                          ></c-table-column>

                          <c-table-column
                              label="操作人"
                              name="repay_user"
                              width="100"
                          ></c-table-column>

                          <c-table-column
                              label="操作时间"
                              name="create_date"
                              width="150"
                          ></c-table-column>
                        </c-table>
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'member_account_credit_info_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                stateName: {
                  0: '未出账',
                  1: '待还款',
                  2: '已还部分',
                  3: '全部还款',
                  4: '已取消'
                },
                billInfo: '',
                sendList: [],
                repayList: []
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getBillInfoDetail();
            }
        },

        mounted() {
            this.getBillInfoDetail();
        },

        methods: {
            getBillInfoDetail() {
                this.request({
                    url: '/credit/bill/info/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.billInfo = data.billInfo;
                        this.sendList = data.sendList;
                        this.repayList = data.repayList;
                    }
                });
          }
        }
    }
</script>